Ember.Handlebars.registerBoundHelper('money', function(value, options) {
    return Billy.money(value, options.hash.currency)
})
